import React from 'react'
import Lottie from 'lottie-react'
import animationData from './red-cube-animation.json'

const RedCubeAnimation = () => {
  return (
    <div style={{ width: 200, height: 200, margin: '0 auto' }}>
      <Lottie 
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  )
}

export default RedCubeAnimation